var _path, _ellipse, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 700 700",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipRule: "evenodd",
      fill: "none",
      stroke: "#929993",
      strokeWidth: 56.6929,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m656 565.4c0 95.2-138.3 93.2-308.9 93.2s-308.9 2-308.9-93.2 138.2-152.4 308.9-152.4 308.9 57.2 308.9 152.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 347.1,
    cy: 213.4,
    rx: 120.6,
    ry: 163.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m358.9 122.4s41.5 59 0 181.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m120.6 556.6s194 34.5 440.3 0"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "account-icon.2e83d62d44e213ff46eaf5ded943ad25.svg";